import React from "react";
import AcademicNav from "../../pages/Dashboard/Academic/AcademicNav";
import AcademicIndex from "../../pages/Dashboard/Academic/AcademicIndex";
import AcademicProfileList from "../../pages/Dashboard/Academic/AcademicProfileList";
import AcademicProfileDetail from "../../pages/Dashboard/Academic/AcademicProfileDetail";
import CurriculumPage from "../../pages/Dashboard/Academic/CurriculumPage";
import TopicStudiedPage from "../../pages/Dashboard/Academic/TopicStudiedPage";
import StageRotationList from "../../pages/Dashboard/Academic/StageRotationList";
import SeminarList from "../../pages/Dashboard/Academic/SeminarList";
import SeminarAttendancesList from "../../pages/Dashboard/Academic/SeminarAttendancesList";
import TakeAttendance from "../../pages/Dashboard/Academic/TakeAttendance";
import AssignmentList from "../../pages/Dashboard/Academic/AssignmentList";

const academicRoutes = {
  path: "/academic",
  element: <AcademicNav />,
  children: [
    { path: "/academic", element: <AcademicIndex /> },
    { path: "/academic/profiles", element: <AcademicProfileList /> },
    { path: "/academic/profiles/view/:id", element: <AcademicProfileDetail /> },
    { path: "/academic/curriculum", element: <CurriculumPage /> },
    { path: "/academic/topic-studied", element: <TopicStudiedPage /> },
    { path: "/academic/stage", element: <StageRotationList /> },
    { path: "/academic/seminars", element: <SeminarList /> },
    { path: "/academic/seminar-attendances", element: <SeminarAttendancesList /> },
    { path: "/academic/take-attendance", element: <TakeAttendance /> },
    { path: "/academic/assignments", element: <AssignmentList /> },
  ],
};

export default academicRoutes;
